<template>
  <div
    v-if="leafletConfig"
    :id="`LeafletSlider-wh-${config.categoryBlockId}`"
    class="leaflet-slider-wrapper LeafletSlider-wh-row"
    :key="config.categoryBlockId + '-' + Date.now()"
  >
    <ebsn-meta
      :target="config"
      path="categoryblocktype_LeafletSliderWrapper.TITLE"
      tag="h2"
    />
    <ebsn-meta
      :target="config"
      path="categoryblocktype_LeafletSliderWrapper.DESCRIPTION"
      tag="div"
    />
    <LeafletsSlider
      v-if="!loading"
      :config="leafletConfig"
      :leafletClasses="null"
      :redirect="false"
    />
    <!-- <LeafletsSlider
      v-if="!loading"
      :parentWarehouseId="parentWarehouseId"
      :parentLeafletTypeId="leafletTypeId"
      :deliveryServiceId="calculatedDeliveryServiceId"
      :config="config"
    /> -->
  </div>
</template>
<style lang="scss">
.leaflet-slider-wrapper {
  // padding: 0 6px;
  // .leaflet-slider {
  //   background-color: transparent !important;
  //   padding: 0 !important;
  //   .swiper-slide {
  //     max-width: 164px !important;
  //   }
  // }

  .leaflet-slider-title {
    font-size: 16px;
    line-height: 22px;
    color: var(--v-primary-base);
    background: var(--v-secondary-base);
    padding: 4px 12px;
    border-radius: 4px;
    width: max-content;
    margin-bottom: 8px;
  }

  .leaflet-descr {
    .leaflet-title {
      display: none;
    }
    .leaflet-date {
      margin-top: 4px;
      font-weight: 600;
      font-family: "Open Sans";
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        font-size: 11px;
      }
    }
  }
  .swiper-container {
    padding: 0 !important;
  }
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
}
</style>
<script>
import LeafletsSlider from "@/components/leaflet/LeafletsSlider.vue";
import get from "lodash/get";

import categoryBlockType from "./categoryBlockType";

// import { mapGetters } from "vuex";

export default {
  name: "LeafletSliderWrapper",
  mixins: [categoryBlockType],
  components: { LeafletsSlider },
  props: {
    config: { type: Object, required: true }
  },
  data() {
    return {
      // style: null,
      loading: true,
      leafletConfig: {
        slidesPerView: 2,
        spaceBetween: 12,
        watchOverflow: true,
        autoplay: false,
        breakpoints: {
          0: {
            slidesPerView: 2
          },
          600: {
            slidesPerView: 2
          },
          960: {
            slidesPerView: 4
          },
          1264: {
            slidesPerView: 6
          },
          1900: {
            slidesPerView: 6
          }
        }
      }
      // parentWarehouseId: null,
      // leafletTypeId: null
    };
  },
  // computed: {
  //   ...mapGetters({
  //     isAuthenticated: "cart/isAuthenticated",
  //     getDeliveryServiceId: "cart/getDeliveryServiceId"
  //   }),
  //   calculatedDeliveryServiceId() {
  //     return this.isAuthenticated ? this.getDeliveryServiceId : undefined;
  //   }
  // },
  methods: {},
  async mounted() {
    // await this.reload();
    try {
      // const leafletTypes = this.$ebsn.meta(
      //   this.config,
      //   "categoryblocktype_LeafletSliderWrapper.LEAFLET_TYPE"
      // );
      // this.leafletTypeId = leafletTypes.filter(
      //   leaflet => leaflet !== null && leaflet !== ""
      // );
      // this.parentWarehouseId = this.$ebsn.meta(
      //   this.config,
      //   "categoryblocktype_LeafletSliderWrapper.WAREHOUSE_ID"
      // );
      this.leafletConfig = get(
        this.config,
        `metaData.categoryblocktype_LeafletSliderWrapper.JSON_CONFIG`,
        this.leafletConfig
      );
      this.loading = false;
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }
};
</script>
